import React from 'react'
import { Grid, Box, Button, DialogActions } from '@material-ui/core'
import { Formik, Form } from 'formik'
import CustomTextField from 'components/Form/CustomTextField'
import { representativeSchema } from 'schemas/representative'
import InfoIconAlongText from 'components/InfoIconAlongText'
import ProgressButton from 'components/ProgressButton'

const RepresentativeForm = ({
  initialValues,
  onSubmit,
  onCancel,
  isPerformingAction,
  isPrimaryContactExists,
  representatives = [],
  editingRepId,
  submitButtonText
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={representativeSchema}
      onSubmit={onSubmit}>
      {({ values, setFieldValue }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
              <CustomTextField label="First Name" name="firstName" type="text" />
            </Grid>
            <Grid item xs={12} md={4}>
              <CustomTextField label="Last Name" name="lastName" type="text" />
            </Grid>
            <Grid item xs={12} md={4}>
              <CustomTextField label="Email" name="email" type="email" />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomTextField label="Credential" name="credential" type="text" />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomTextField label="Position/Title" name="position" type="text" />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomTextField label="Organization" name="company" type="text" disabled />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomTextField label="Phone" name="phone" type="text" />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomTextField label="City" name="city" type="text" />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomTextField label="State" name="state" type="text" />
            </Grid>

            <Grid item xs={12} md={4}>
              <CustomTextField label="Country" name="country" type="text" />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <input
                  type="checkbox"
                  id="isPrimaryContact"
                  name="isPrimaryContact"
                  checked={values.isPrimaryContact}
                  onChange={() => setFieldValue('isPrimaryContact', !values.isPrimaryContact)}
                  disabled={
                    editingRepId
                      ? representatives.some(
                          (rep) => rep.isPrimaryContact && rep.id !== editingRepId
                        )
                      : isPrimaryContactExists
                  }
                />
                <label htmlFor="isPrimaryContact" style={{ margin: '0px 8px', cursor: 'pointer' }}>
                  Primary Contact
                </label>
                {(editingRepId
                  ? representatives.some((rep) => rep.isPrimaryContact && rep.id !== editingRepId)
                  : isPrimaryContactExists) && (
                  <InfoIconAlongText infoText="Primary contact already exists." />
                )}
              </Box>
            </Grid>
          </Grid>

          <DialogActions style={{ display: 'flex', gap: '12px', padding: '10px 0px' }}>
            <Button onClick={onCancel} disabled={isPerformingAction}>
              Cancel
            </Button>
            <ProgressButton
              type="submit"
              inProgress={isPerformingAction}
              label={submitButtonText}
              disabled={isPerformingAction}
            />
          </DialogActions>
        </Form>
      )}
    </Formik>
  )
}

export default RepresentativeForm
